import { format, isValid, parseISO } from 'date-fns'

export type WalletTransactionsDateRangePreset = 'week' | 'month'

export type WalletTransactionsBrandFilter = 'kool' | 'yassir'

export type WalletTransactionsFilters = {
  brand?: WalletTransactionsBrandFilter
  dateRange?: WalletTransactionsDateRangePreset
  dateFrom?: string
  dateTo?: string
}

export const EMPTY_WALLET_TRANSACTIONS_FILTERS: WalletTransactionsFilters = {}

export type FetchWalletTransactionsQueryParams = {
  limit?: number
  offset?: number
  brand?: string
  dateRange?: WalletTransactionsDateRangePreset
  dateFrom?: string
  dateTo?: string
}

const isValidIsoDate = (value?: string): value is string => {
  if (!value) return false

  const parsed = parseISO(value)
  return isValid(parsed)
}

export const isValidCustomWalletTransactionsDateRange = (
  dateFrom?: string,
  dateTo?: string
): boolean => {
  if (!dateFrom || !dateTo) return false
  if (!isValidIsoDate(dateFrom) || !isValidIsoDate(dateTo)) return false

  return dateTo >= dateFrom
}

export const formatWalletTransactionsFilterDate = (date: Date): string =>
  format(date, 'yyyy-MM-dd')

type BuildFetchWalletTransactionsParamsArgs = {
  limit?: number
  offset?: number
  filters?: WalletTransactionsFilters
}

export const buildFetchWalletTransactionsParams = ({
  limit,
  offset,
  filters = EMPTY_WALLET_TRANSACTIONS_FILTERS
}: BuildFetchWalletTransactionsParamsArgs): FetchWalletTransactionsQueryParams => {
  const params: FetchWalletTransactionsQueryParams = {
    limit,
    offset
  }

  if (filters.brand) {
    params.brand = filters.brand
  }

  if (filters.dateRange) {
    params.dateRange = filters.dateRange
    return params
  }

  if (
    isValidCustomWalletTransactionsDateRange(filters.dateFrom, filters.dateTo)
  ) {
    params.dateFrom = filters.dateFrom
    params.dateTo = filters.dateTo
  }

  return params
}
